import Node from './node';

export default class Actions extends Node {

}
